// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Notification Management */
.notification-management-page .dashboard-body {
  padding-bottom: 2rem;
}

.notification-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.notification-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.notification-stat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.notification-stat-card__value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.notification-stat-card__label {
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

.notification-stat-card--active .notification-stat-card__value {
  color: #16a34a;
}

.notification-stat-card--inactive .notification-stat-card__value {
  color: #dc2626;
}

.notification-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.notification-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  background: #f1f5f9;
  color: var(--text, #475569);
}

.notification-tab:hover {
  background: #e2e8f0;
}

.notification-tab--active {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.notification-tab--active:hover {
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
}

.notification-content {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border, #e2e8f0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.notification-section {
  padding: 1.5rem;
}

.notification-section__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification-section__title i {
  color: #0f766e;
}

.notification-form__group {
  margin-bottom: 1.25rem;
}

.notification-form__group label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text, #1e293b);
}

.notification-form__group .required {
  color: #dc2626;
}

.notification-form__group input,
.notification-form__group textarea {
  width: 100%;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  color: var(--text, #1e293b);
}

.notification-form__group input:focus,
.notification-form__group textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.notification-form__group textarea {
  resize: vertical;
  min-height: 120px;
}

.notification-form__group--relative {
  position: relative;
}

.notification-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.notification-suggestion-item {
  padding: 0.65rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}

.notification-suggestion-item:last-child {
  border-bottom: none;
}

.notification-suggestion-item:hover {
  background: #f8fafc;
}

.notification-suggestion-name {
  font-weight: 600;
  font-size: 0.9rem;
}

.notification-suggestion-email {
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.notification-selected-users {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.notification-selected-user {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  background: #ccfbf1;
  border-radius: 8px;
  font-size: 0.875rem;
}

.notification-selected-user-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.notification-selected-user-name {
  font-weight: 600;
}

.notification-selected-user-email {
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
}

.notification-btn-remove {
  padding: 0.2rem;
  font-size: 0.9rem;
  color: #64748b;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.notification-btn-remove:hover {
  color: #dc2626;
  background: #fef2f2;
}

.notification-form__actions {
  margin-top: 1.5rem;
}

.notification-btn-send {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.notification-btn-send:hover {
  opacity: 0.95;
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
}

.notification-placeholder {
  margin: 0;
  color: var(--text-muted, #64748b);
  font-size: 0.95rem;
}

.notification-table-wrap {
  overflow-x: auto;
}

.notification-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.notification-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.notification-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
}

.notification-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.notification-table tbody tr:hover {
  background: #f8fafc !important;
}

.notification-table__msg {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notification-status-badge {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.notification-status-badge--active {
  background: #dcfce7;
  color: #166534;
}

.notification-status-badge--inactive {
  background: #fef2f2;
  color: #b91c1c;
}

.notification-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.notification-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.notification-action-btn:hover {
  opacity: 0.9;
}

.notification-action-btn--delete {
  background: #dc2626;
  color: #fff;
}

.notification-action-btn--inactive {
  background: #ea580c;
  color: #fff;
}

.notification-action-btn--active {
  background: #16a34a;
  color: #fff;
}

.notification-empty {
  padding: 2.5rem 1rem;
  text-align: center;
  color: var(--text-muted, #64748b);
}

.notification-empty i {
  font-size: 2.5rem;
  display: block;
  margin-bottom: 0.75rem;
  opacity: 0.5;
}

.notification-empty p {
  margin: 0;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .notification-stats {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Notification/NotificationManagementPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Notification Management */\n.notification-management-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.notification-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.notification-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.notification-stat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.notification-stat-card__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.notification-stat-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n.notification-stat-card--active .notification-stat-card__value {\n  color: #16a34a;\n}\n\n.notification-stat-card--inactive .notification-stat-card__value {\n  color: #dc2626;\n}\n\n.notification-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.notification-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #f1f5f9;\n  color: var(--text, #475569);\n}\n\n.notification-tab:hover {\n  background: #e2e8f0;\n}\n\n.notification-tab--active {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.notification-tab--active:hover {\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n}\n\n.notification-content {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border, #e2e8f0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.notification-section {\n  padding: 1.5rem;\n}\n\n.notification-section__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.notification-section__title i {\n  color: #0f766e;\n}\n\n.notification-form__group {\n  margin-bottom: 1.25rem;\n}\n\n.notification-form__group label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text, #1e293b);\n}\n\n.notification-form__group .required {\n  color: #dc2626;\n}\n\n.notification-form__group input,\n.notification-form__group textarea {\n  width: 100%;\n  padding: 0.7rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text, #1e293b);\n}\n\n.notification-form__group input:focus,\n.notification-form__group textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.notification-form__group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.notification-form__group--relative {\n  position: relative;\n}\n\n.notification-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n}\n\n.notification-suggestion-item {\n  padding: 0.65rem 1rem;\n  cursor: pointer;\n  border-bottom: 1px solid #f1f5f9;\n  transition: background 0.15s;\n}\n\n.notification-suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.notification-suggestion-item:hover {\n  background: #f8fafc;\n}\n\n.notification-suggestion-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.notification-suggestion-email {\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n}\n\n.notification-selected-users {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.notification-selected-user {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.75rem;\n  background: #ccfbf1;\n  border-radius: 8px;\n  font-size: 0.875rem;\n}\n\n.notification-selected-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.notification-selected-user-name {\n  font-weight: 600;\n}\n\n.notification-selected-user-email {\n  font-size: 0.75rem;\n  color: var(--text-muted, #64748b);\n}\n\n.notification-btn-remove {\n  padding: 0.2rem;\n  font-size: 0.9rem;\n  color: #64748b;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.notification-btn-remove:hover {\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n.notification-form__actions {\n  margin-top: 1.5rem;\n}\n\n.notification-btn-send {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.notification-btn-send:hover {\n  opacity: 0.95;\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n}\n\n.notification-placeholder {\n  margin: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 0.95rem;\n}\n\n.notification-table-wrap {\n  overflow-x: auto;\n}\n\n.notification-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.notification-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.notification-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.notification-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.notification-table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.notification-table__msg {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.notification-status-badge {\n  display: inline-block;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.notification-status-badge--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.notification-status-badge--inactive {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.notification-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.notification-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.7rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.notification-action-btn:hover {\n  opacity: 0.9;\n}\n\n.notification-action-btn--delete {\n  background: #dc2626;\n  color: #fff;\n}\n\n.notification-action-btn--inactive {\n  background: #ea580c;\n  color: #fff;\n}\n\n.notification-action-btn--active {\n  background: #16a34a;\n  color: #fff;\n}\n\n.notification-empty {\n  padding: 2.5rem 1rem;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n}\n\n.notification-empty i {\n  font-size: 2.5rem;\n  display: block;\n  margin-bottom: 0.75rem;\n  opacity: 0.5;\n}\n\n.notification-empty p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n@media (max-width: 768px) {\n  .notification-stats {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
